import { getCpAdminProjectInfo, getBuildProductList } from '@/api/index';
import { ElMessage } from "element-plus";
const state = {
  project: {},
  proInfo: {
    id: '',
    info: {}
  },
  authority: false, // 项目操作权限
  proList: [],
  firstProList: [],
  proListObj: {
    page: 1,
    page_size: 20,
    is_next: true,
    total: 0,
    request_id: ''
  },
  isGetPromission: false
};

const mutations = {
  project(state, info) {
    state.project = info;
  },
  updataProInfo(state, obj) {
    if (obj.info.status_code == -3 && obj.info.temp_id && obj.info.pro_class != '201') {
      sessionStorage.setItem('isTemp', true)
    } else {
      sessionStorage.removeItem('isTemp')
    }
    state.proInfo = obj;
  },
  updataAuthority(state, bol) {
    state.authority = bol;
  },
  updataProList(state, obj) {
    state.proList = obj.list
    if (obj.page == 1) {
      state.firstProList = obj.list
    }
    state.isGetPromission = state.proList.length > 0
  },
  updataProObj(state, obj) {
    state.proListObj = {...state.proListObj, ...obj};
  }
};
var loading = false
var listoading = false
const actions = {
  getProInfo({ commit }, pro_id) {
    if (loading) return
    loading = true
    return getCpAdminProjectInfo({ pro_id }).then(({ status, data, message }) => {
        loading = false
        if (status == 0 && data) {
            commit('updataProInfo', {
                id: pro_id,
                info: data,
            });
            commit('updataAuthority', true);
            return
        } else {
            commit('updataProInfo', {
                id: pro_id,
                info: {},
            });
            commit('updataAuthority', false);
            ElMessage({
                type: 'warning',
                customClass: 'waring-customize',
                message: message,
            })
            return
        }
    })
},
  // 获取发起的项目列表
  async getProList({ commit, rootState }, page) {
    if (listoading) return
    listoading = true
    const { status, data } = await getBuildProductList({ 
      to_user_id: rootState.user.user_id,
      page: page,
      page_size: 10,
    });
    listoading = false
    if (status == 0) {
      commit('updataProList', {
        list: data.list,
        page: page
      });
      commit('updataProObj', data);
    } else {
      commit('updataProList', {
        list: [],
        page: page
      });
      commit('updataProObj', {
        page: 1,
        page_size: 10,
        is_next: false,
        total: 0,
        request_id: ''
      });
    }
  }
};

export default {
  state,
  mutations,
  actions,
};
